import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() { }
  /**
   * setItem
   */
  public setItem(key: string, value: string) {
    sessionStorage.setItem(key, value);
  }

  /**
   * getItem
   */
  public getItem(key: string) {
    return sessionStorage.getItem(key);
  }

  /**
   * clear
   */
  public clear() {
    sessionStorage.clear();
  }

  /**
   * removeItem
   */
  public removeItem(key: string) {
    sessionStorage.removeItem(key);
  }

  /**
   * key
   */
  public key(index: number) {
    return sessionStorage.key(index);
  }

}
